export default "__VITE_ASSET__1c44cd3c__"